import { Typography, styled } from '@mui/material'
import { CancelButton, SecondaryButton } from '$common/buttons'
import { WarningOutlinedIcon } from '$common/icons'
import { BottomDrawer } from '$common/bottom-drawer'
import { t } from '$i18n'

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 5px 20px 20px;
`

const Actions = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 12px;
`

const IconContainer = styled('div')`
  border: 1px solid #0000000d;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #e6494f1a;
  margin-bottom: 20px;
`

export interface Props {
  isOpen?: boolean
  onConfirm: () => unknown
  onCancel: () => unknown
}
export function IOSCallProblems({ isOpen, onConfirm, onCancel }: Props) {
  return (
    <BottomDrawer isOpen={isOpen!} onClose={onCancel}>
      <Root>
        <IconContainer style={{ height: '160px', width: '100%' }}>
          <WarningOutlinedIcon />
        </IconContainer>

        <Typography
          dir="auto"
          variant="body2"
          sx={{
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            textAlign: 'right',
          }}
        >
          {t('iosCallProblemsModal.description')}
        </Typography>

        <Actions>
          <SecondaryButton
            fullWidth
            text={t('iosCallProblemsModal.confirmText')}
            onClick={onConfirm}
          />

          <CancelButton
            sx={{ width: '100%' }}
            text={t('common.cancel')}
            onClick={onCancel}
          />
        </Actions>
      </Root>
    </BottomDrawer>
  )
}

IOSCallProblems.defaultProps = {
  isOpen: false,
}
